import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Timer = () => (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.00008 15.1667C4.50675 15.1667 1.66675 12.3267 1.66675 8.83333C1.66675 5.34 4.50675 2.5 8.00008 2.5C11.4934 2.5 14.3334 5.34 14.3334 8.83333C14.3334 12.3267 11.4934 15.1667 8.00008 15.1667ZM8.00008 3.5C5.06008 3.5 2.66675 5.89333 2.66675 8.83333C2.66675 11.7733 5.06008 14.1667 8.00008 14.1667C10.9401 14.1667 13.3334 11.7733 13.3334 8.83333C13.3334 5.89333 10.9401 3.5 8.00008 3.5Z" />
    <path d="M8 9.16665C7.72667 9.16665 7.5 8.93998 7.5 8.66665V5.33331C7.5 5.05998 7.72667 4.83331 8 4.83331C8.27333 4.83331 8.5 5.05998 8.5 5.33331V8.66665C8.5 8.93998 8.27333 9.16665 8 9.16665Z" />
    <path d="M10 1.83331H6C5.72667 1.83331 5.5 1.60665 5.5 1.33331C5.5 1.05998 5.72667 0.833313 6 0.833313H10C10.2733 0.833313 10.5 1.05998 10.5 1.33331C10.5 1.60665 10.2733 1.83331 10 1.83331Z" />
  </svg>
)

export default withDefaultStyles(Timer)
